import { RouterProvider } from "react-router-dom";

import { useAppInit } from "@/hooks/useAppInit";
import { router } from "@/routes";

/** 根组件：应用 bootstrap + 路由 */
const App = () => {
  useAppInit();
  return <RouterProvider router={router} />;
};

export default App;
